<template>
  <div class="search_" v-show="showSearch">
    <div class="con_">
      <span class="close_btn" @click="close"></span>
      <div class="titleBody">
        <b>请输入客户名：</b>
        <a-input v-model="searchKey" placeholder="请输入客户名称"></a-input>
        <button @click="searchName">查询</button>
      </div>
      <p class="titleBottom" v-show="isshow">
        <b>查询结果：{{ backText }}</b>
      </p>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
export default {
  props: {
    showSearch: {
      type: Boolean,
      default: true,
    },
    close: {
      type: Function,
      default: function() {
        if (
          navigator.userAgent.indexOf("Firefox") != -1 ||
          navigator.userAgent.indexOf("Chrome") != -1
        ) {
          window.location.href = "about:blank";

          window.close();
        } else {
          window.opener = null;

          window.open("", "_self");

          window.close();
        }
      },
    },
  },
  data() {
    return {
      searchKey: "",
      isshow: false,
      testshow: false,
      backText: ""
    };
  },
  methods: {
    getBackText(is, data) {
      if (is === "Y" && data != null){
        this.backText = "该客户为首次投保，可以使用SME报价器进行报价。";
      } else {
        this.backText = "未在企查查中查询到相关企业信息，请核对。";
      }
    },
    async searchName() {
      if (this.searchKey) {
        let res = await api.queryCustomerCanInsure(this.searchKey);
        if (res.data.content === "Y") {
          const prams = {
            keyWord: this.searchKey,
            publicKey: "nanyan"
          };
          let resC = await api.queryEnterpriseBank(prams);
          let data = resC.data.content ? resC.data.content.creditcode : null;
          this.getBackText(res.data.content, data);
        } else {
          this.backText = '该客户已存在线下报价记录，不支持使用报价计算器报价';
        }
        this.isshow = true;
      } else {
        this.isshow = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search_ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 5;
  .con_ {
    background-color: #fff;
    width: 90%;
    height: 40vh;
    border-radius: 15px;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    padding: 10px 15px 20px;
    .close_btn {
      position: absolute;
      top: 10px;
      right: 10px;
      display: block;
      width: 25px;
      height: 25px;
      background: url(../../../assets/quote/closeicon.png) center center
        no-repeat;
      background-size: 25px 25px;
    }
    .titleBody {
      height: 75%;
      display: flex;
      white-space: nowrap;
      white-space: nowrap;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      input {
        width: 60%;
        margin: 0 2vw;
      }
    }
    .titleBottom {
      text-align: center;
    }
    button {
      width: 100px;
      height: 30px;
      background-color: #3d5ed5;
      border: none;
      outline: 0;
      color: #fff;
      display: block;
      border-radius: 5px;
    }
  }
}
</style>
